export default __webpack_public_path__ + "static/dna-8ab6db4cb188a8237f26a8de734dc359.mp4";